import { makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { Text, TextProps } from '../';

type Override<T1, T2> = Omit<T1, keyof T2> & T2;

export type ChipColorScheme =
  'info' | 'success' | 'error' | 'warning' | 'fulfilled' | 'mint' | 'lightBlue' |
  'quotesLightBlue' | 'quotesLightGreen' | 'quotesLightOrange' | 'quotesLightRed' | 'quotesLightYellow';

export type ChipProps = Override<
  TextProps,
  {
    colorScheme?: ChipColorScheme;
  }
>;

const useStyles = makeStyles((theme: Theme) => ({
  default: {
    borderRadius: 50,
    padding: '0 18px',
    width: 'fit-content',
  },
  info: {
    backgroundColor: '#F0F0F0',
    color: '#515151',
  },
  success: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark,
  },
  error: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.dark,
  },
  warning: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  },
  fulfilled: {
    backgroundColor: '#ddeafe',
    color: '#1a192e',
  },
  mint: {
    color: theme.branding.mint,
    backgroundColor: 'RGBA(0, 189, 133, 0.1)',
  },
  lightBlue: {
    backgroundColor: 'RGBA(0, 95, 255, 0.15)',
    color: '#515151',
  },
  /* I hate doing this, but I think this whole thing can be saved with a consistent color palette */
  quotesLightBlue: {
    backgroundColor: theme.branding.lightBlue,
  },
  quotesLightGreen: {
    backgroundColor: theme.branding.lightGreen,
  },
  quotesLightOrange: {
    backgroundColor: theme.branding.lightOrange,
  },
  quotesLightRed: {
    backgroundColor: theme.branding.lightRed,
  },
  quotesLightYellow: {
    backgroundColor: theme.branding.lightYellow
  },
}));

const Chip: React.FC<ChipProps> = (props: ChipProps) => {
  const { colorScheme, className = '', children, ...restOfProps } = props;
  const classes = useStyles();

  return (
    <Text
      presetFont="txt--xs"
      className={`${colorScheme ? classes[colorScheme] : ''} ${classes.default} ${className}`}
      {...restOfProps}
    >
      {children}
    </Text>
  );
};

export default Chip;
